<app-summary-field *ngIf="price || price === 0" [label]="label" [color]="color" [iconName]="iconName">
    <app-price-label [price]="price" [color]="color"></app-price-label>
</app-summary-field>
